import type { PricingList } from 'api/types/pricing.types';

type AddOnType = 'RESTORATION' | 'SOLE_ICING' | 'STAIN_PROTECTION';

const KeyMap = {
  RESTORATION: 'LIGHT_RESTORATION',
  SOLE_ICING: 'ICING',
  STAIN_PROTECTION: 'STAIN_PROTECTION',
};
export const getShoeAddOnPricing = (data: PricingList.PerItemService, addOnType: AddOnType): number => {
  const addOns = data.itemCategories.find((i) => i.key === 'ADD_ONS');
  const addOn = addOns?.itemTypes.find((t) => t.key === KeyMap[addOnType]);
  return addOn?.price ?? 0;
};
